import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=9255dde6&scoped=true&"
import script from "./editTag.vue?vue&type=script&lang=ts&"
export * from "./editTag.vue?vue&type=script&lang=ts&"
import style0 from "./editTag.vue?vue&type=style&index=0&id=9255dde6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9255dde6",
  null
  
)

export default component.exports